import { defineQuery } from 'next-sanity'
import { videoFields } from './fragments/video'

export const videoBySlugQuery = defineQuery(`
  *[_type == "video" && slug.current == $slug]{
    ...,
    title,
    defined(description[0]) => {
      description[] {
        ...,
        markDefs[] {
          ...,
          _type == 'definition' => {
            _key,
            _type,
            "title": definitionRef->title,
            "content": definitionRef->text
          },
          'internalLink': {
            "_type": reference->_type,
            "slug": reference->slug.current
          }
        }
      }
    },
    !defined(description[0]) => {
      description
    },
    caption,
    videoType,
    publishedAt,
    _updatedAt,
    "slug": slug.current,
    ${videoFields},
    "lessonRef": *[_type == 'lesson' && references(^._id)] {
      topic[0]-> {
        _type,
        title,
        "illustration": illustration.webp.asset->
      },
      title,
      _id,
      "slug": slug.current
    }
  } | order(_updatedAt desc)[0]
`)
